import { render, staticRenderFns } from "./CustSeats.vue?vue&type=template&id=3f7f72fc&"
import script from "./CustSeats.vue?vue&type=script&lang=js&"
export * from "./CustSeats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports